// mutation types
export const LOADING = 'loading'
export const LOADED = 'loaded'
export const SET_LOADING_MESSAGE = 'setLoadingMessage'
export const SET_PROMISE_CHAIN = 'setPromiseChain'
export const ERROR = 'error'

export const SET_LOCALE = 'setLocale'
export const SET_MODULE_PROPERTY = 'setModuleProperty'
export const SET_MODEL = 'setModel'
export const UPDATE_MODEL = 'updateModel'
export const SET_LIST = 'setList'
export const SHIFT_LIST = 'shiftList'
export const UPDATE_LIST_ITEM_PROPS = 'updateListItemProps'
export const SET_PARAMS = 'setParams'
export const UPDATE_PARAMS = 'updateParams'
export const SET_CONVERSIONS_SYNC_DATE = 'setConversionsSyncDate'

// dictionary
export const DICTIONARY = 'dictionary'

// common: type
export const COMMON = 'common'
// common: action types
export const LOADING_DATA = 'updatingData'
export const LOADED_DATA = 'updatedData'
export const ADD_ACTION_IN_QUEUE = 'addActionInQueue'

// session: type
export const SESSION = 'session'
// session: action types
export const CREATE_SESSION_WITH_CODE = 'createSessionWithCode'
export const CREATE_SESSION_FOR_VIEW = 'createSessionForView'
export const GET_SESSION_ACCOUNT = 'getSessionAccount'
export const REMOVE_SESSION = 'removeSession'
export const REFRESH_SESSION = 'refreshSession'
export const RESET_SESSION = 'resetSession'
export const SET_LOCAL_PROMPT = 'setLocalPrompt'
export const REMOVE_LOCAL_PROMPT = 'removeLocalPrompt'
export const GET_ACCOUNT_LIST = 'getAccountList'
export const SET_ACCOUNT_LIST = 'setAccountList'
export const REMOVE_ACCOUNT_LIST = 'removeAccountList'
export const SELECT_ACCOUNT = 'selectAccount'

// placements: types
export const GENERAL_CONFIGURATION = 'generalConfiguration'
export const WORST_PLACEMENTS = 'worstPlacements'
export const DISPUTED_PLACEMENTS = 'disputedPlacements'
export const BEST_PLACEMENTS = 'bestPlacements'
export const BLACKLIST_PLACEMENTS = 'blackListPlacements'
export const WHITELIST_PLACEMENTS = 'whiteListPlacements'
// placements: action types
export const FETCH_ALL_PLACEMENTS = 'fetchAllPlacements'
export const FETCH_PLACEMENTS_BY_TYPE = 'fetchPlacementsByType'
export const FETCH_BLACKLIST_PLACEMENTS = 'fetchBlackListPlacements'
export const FETCH_WHITELIST_PLACEMENTS = 'fetchWhiteListPlacements'
export const CHANGE_BLACKLIST_PLACEMENTS = 'changeBlackListPlacements'
export const CHANGE_WHITELIST_PLACEMENTS = 'changeWhiteListPlacements'
export const MOVE_BLACKLIST_PLACEMENTS_TO_WHITELIST = 'moveBlacklistPlacementsToWhitelist'
export const ADD_PLACEMENTS_TO_BLACKLIST_FROM_FILE = 'addPlacementsToWhitelistFromFile'
export const ADD_PLACEMENTS_TO_WHITELIST_FROM_FILE = 'addPlacementsToBlacklistFromFile'
export const ADD_PLACEMENTS_TO_BLACKLIST_MANUALLY = 'addPlacementsToBlacklistManually'
export const ADD_PLACEMENTS_TO_WHITELIST_MANUALLY = 'addPlacementsToWhitelistManually'
export const ADD_ALL_PLACEMENTS_TO_WHITELIST = 'addAllPlacementsToWhitelist'
export const ADD_ALL_PLACEMENTS_TO_BLACKLIST = 'addAllPlacementsToBlacklist'

// keywords: types
export const WORST_KEYWORDS = 'worstKeywords'
export const DISPUTED_KEYWORDS = 'disputedKeywords'
export const BEST_KEYWORDS = 'bestKeywords'
export const EXCEPTION_KEYWORDS = 'exceptionKeywords'
// keywords: action types
export const FETCH_KEYWORDS = 'fetchKeywords'
export const FETCH_EXCEPTION_KEYWORDS = 'fetchExceptionKeywords'
export const CHANGE_KEYWORDS_STATUS = 'changeKeywordsStatus'
export const CHANGE_EXCEPTION_KEYWORDS = 'changeExceptionKeywords'
export const CHANGE_KEYWORDS_STATUS_FROM_ACTION_LOG = 'changeKeywordsStatusFromActionLog'

// ads: types
export const WORST_ADS = 'worstAds'
export const DISPUTED_ADS = 'disputedAds'
export const EXCEPTION_ADS = 'exceptionAds'
// ads: action types
export const FETCH_ADS = 'fetchAds'
export const FETCH_EXCEPTION_ADS = 'fetchExceptionAds'
export const CHANGE_ADS_STATUS = 'changeAds'
export const CHANGE_EXCEPTION_ADS = 'changeExceptionAds'
export const CHANGE_ADS_STATUS_FROM_ACTION_LOG = 'changeAdsStatusFromActionLog'

// action log: type
export const ACTION_LOG = 'actionLogList'
export const ACTION_LOG_PLACEMENTS = 'actionLogPlacements'
export const ACTION_LOG_KEYWORDS = 'actionLogKeywords'
export const ACTION_LOG_ADS = 'actionLogAds'
// action log: action types
export const FETCH_ACTION_LOG = 'fetchActionLog'
export const FETCH_ACTION_LOG_ITEM = 'fetchActionLogItem'

// account settings: type
export const ACCOUNT_SETTINGS = 'accountSettings'
// account settings: action types
export const GET_ACCOUNT_SETTINGS = 'getAccountSettings'
export const CHANGE_ACCOUNT_SETTING = 'changeAccountSetting'
export const SAVE_NOTIFICATION_TOOLS = 'saveNotificationTools'
export const ADD_NOTIFICATION_TOOLS = 'addNotificationTools'
export const REMOVE_NOTIFICATION_TOOLS = 'removeNotificationTools'
export const SAVE_MASKS = 'saveMasks'

// summary: type
export const SUMMARY = 'summary'
// summary: action types
export const FETCH_SUMMARY = 'fetchSummary'

// notifications
export const NOTIFICATIONS = 'notifications'
export const PUSH_NOTIFICATION = 'pushNotification'

export const CAMPAIGNS = 'campaigns'
export const FETCH_CAMPAIGNS = 'fetchCampaigns'
